<template>
  <div class="container-view">
    <Breadcrumbs />
    <div class="col-12 filter-container-card">
      <Filtros @filterList="filterList" />
    </div>
    <div class="col-12 list-container-card">
      <Listado
        :authorizations="this.authorizations"
        :isLoading="isLoadingList"
        @refreshList="this.callData"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Listado from '../components/Listado.vue';
import Filtros from '../components/Filtros.vue';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import Message from '@/components/shared/mixins/Message.js';

export default {
  computed: {
    ...mapGetters({
      isAdmin: 'PF/isAdmin',
      isSuperAdmin: 'PF/isSuperAdmin'
    })
  },
  components: {
    Listado,
    Breadcrumbs,
    Filtros
  },
  mixins: [Loading, Message],
  data: function () {
    return {
      authorizations: [],
      requestFilterData: {
        status: '',
        entityId: '',
        applicationId: ''
      },
      isLoadingList: false
    };
  },
  methods: {
    callData () {
      this.showLoading();
      this.isLoadingList = true;

      const request = {
        controller: `/SolicitudAcceso?Status=${this.requestFilterData.status}&EntityId=${this.requestFilterData.entityId}&ApplicationId=${this.requestFilterData.applicationId}`
      };

      this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.authorizations = response.data;
        })
        .catch((err) => {
          this.showError(err.message);
        })
        .finally(() => {
          this.hideLoading();
          this.isLoadingList = false;
        });
    },
    filterList (filterElement) {
      this.requestFilterData.status = filterElement.status;
      this.requestFilterData.entityId = filterElement.entityId;
      this.requestFilterData.applicationId = filterElement.applicationId;

      this.callData();
    }
  }
};
</script>
<style lang="scss" scoped>
.container-view {
  .filter-container-card {
    margin-bottom: 32px;
  }
}
</style>
